const azureBlue = {
  main: "#0DA8E1",
  light: "#31b7e8",
  dark: "#0781ad",
};

export { azureBlue };
